import { resolveTypographyVariantStyles } from '@aspendental/themes';
import { Theme } from '@mui/material';

export const stepperStyles = (params: {
	theme: Theme;
	isSmallScreen: boolean;
	hideStepperDot: boolean;
	useNumericStepper?: boolean;
	withStepIcon?: boolean;
	areStepsCenteredForMobile?: boolean;
}) => {
	const hideDotAndSmallScreen = params.isSmallScreen && params.hideStepperDot;

	return {
		'.MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
			borderColor: params.theme.palette.neutrals?.primary,
			height: '1.5rem',
			marginLeft: params.isSmallScreen ? '-0.4rem' : null,
		},
		'.MuiStepLabel-root.MuiStepLabel-vertical': {
			paddingTop: '0',
			textAlign: params.hideStepperDot ? 'center' : 'start',
			...(params.isSmallScreen && params.areStepsCenteredForMobile && { flexDirection: 'column' }),
		},
		'.MuiStepLabel-iconContainer.Mui-completed': {
			display: hideDotAndSmallScreen ? 'none' : 'block',
			paddingTop: params.isSmallScreen ? '.6rem' : null,
			...(params.isSmallScreen && params.areStepsCenteredForMobile && { paddingRight: 0 }),
		},
		'.MuiStepConnector-root.MuiStepConnector-vertical.Mui-completed': {
			display: hideDotAndSmallScreen ? 'flex' : null,
			justifyContent: hideDotAndSmallScreen ? 'center' : null,
			marginLeft: hideDotAndSmallScreen ? '0' : null,
		},
		'.MuiStep-root.MuiStep-horizontal.MuiStep-alternativeLabel.Mui-completed': {
			padding: ' 0 1rem',
		},
		'.MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel': {
			marginTop: '0.8rem',
		},
		...((params.useNumericStepper || params.withStepIcon) && {
			'.MuiStepConnector-root.MuiStepConnector-horizontal': {
				top: '1.275rem',
			},
		}),

		...(params.isSmallScreen &&
			params.areStepsCenteredForMobile && {
				alignItems: 'center',
			}),
	};
};

export const stepLabelStyles = (params: {
	theme: Theme;
	isSmallScreen: boolean;
	hideStepperDot: boolean;
	useNumericStepper?: boolean;
	withStepIcon?: boolean;
}) => {
	const hideDotAndSmallScreen = params.isSmallScreen && params.hideStepperDot;
	const customStepIconColor = params.withStepIcon
		? params.theme.palette.tertiary.main
		: params.theme.palette.success.main;
	const withNumericIconColor = params.useNumericStepper ? 'transparent' : params.theme.palette.success.main;
	return {
		'.MuiSvgIcon-root': {
			display: hideDotAndSmallScreen ? 'none' : 'block',
			fontSize: params.useNumericStepper ? '2rem' : '0.8rem',
			fontWeight: 'bold',
			color: params.withStepIcon ? customStepIconColor : withNumericIconColor,
			textAlign: 'left',
		},
		'.MuiStepIcon-text': {
			display: params.useNumericStepper ? 'block' : 'none',
			fill: params.theme.palette.tertiary?.main,
		},
	};
};

export const stepperContainerStyle = (isSmallScreen: boolean) => {
	return { marginTop: isSmallScreen ? '2.25rem' : '2.75rem' };
};

export const getLinkTitleStyles = (theme: Theme, isSmallScreen: boolean, isHighlightedSteps?: boolean) => ({
	...resolveTypographyVariantStyles(theme, 'p'),
	cursor: 'pointer',
	color: isHighlightedSteps ? theme.palette.secondary.main : theme.palette.primary.main,
	fontWeight: isHighlightedSteps ? '600' : '400',
	fontSize: isSmallScreen ? '1.1rem' : '1rem',
});
